var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('reports',{attrs:{"reports":_vm.reports,"reportType":_vm.reportType,"reportLabel":_vm.reportLabel,"filter":_vm.selectedFilter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }